// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scanner-buttons {
  margin: 0px;
  position: absolute;
  bottom: 100px;
  width: 100vw;
  height: 50px;
  z-index: 11;
}

.scan-box {
  border: 2px solid #fff;
  box-shadow: 0 0 0 100vmax rgba(0, 0, 0, 0.5);
  content: "";
  display: block;
  left: 50%;
  height: calc(300 * var(--width-ratio));
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: calc(300 * var(--width-ratio));
}`, "",{"version":3,"sources":["webpack://./src/app/shared/modal/barcode-scanner-modal/barcode-scanner-modal.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;AACF;;AAEA;EACE,sBAAA;EACA,4CAAA;EACA,WAAA;EACA,cAAA;EACA,SAAA;EACA,sCAAA;EACA,kBAAA;EACA,QAAA;EACA,gCAAA;EACA,qCAAA;AACF","sourcesContent":[".scanner-buttons {\n  margin: 0px;\n  position: absolute;\n  bottom: 100px;\n  width: 100vw;\n  height: 50px;\n  z-index: 11;\n}\n\n.scan-box {\n  border: 2px solid #fff;\n  box-shadow: 0 0 0 100vmax rgba(0, 0, 0, 0.5);\n  content: \"\";\n  display: block;\n  left: 50%;\n  height: calc(300 * var(--width-ratio));\n  position: absolute;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  width: calc(300 * var(--width-ratio));\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
